import { PaymentFormComponent } from './../../shared/components/payment-form/payment-form.component';
import { AfterViewInit, Component, OnDestroy, ViewChild, ViewEncapsulation, OnInit } from "@angular/core";
import { ActivatedRoute, Router, RoutesRecognized } from "@angular/router";
// Constants
import { SYDLEClientID } from "../../shared/constants/one-constants";
// Enums
import { Dtm, getDtm, Mapping } from "../../shared/enum/dtm";
// Models
import { Cart } from "../../shared/model/cart";
import { Customer } from "../../shared/model/customer";
import { CustomerPaymentMethod } from "../../shared/model/customer-payment-method";
import { CreditCardData } from 'src/app/shared/model/credit-card-data';
import { SuggestionMessage } from './../../shared/model/sugestion-message';
// Services
import { CartService } from "../../shared/services/cart.service";
import { CheckoutService } from "../../shared/services/checkout.service";
import { CustomerService } from "../../shared/services/customer.service";
import { ProductService } from "../../shared/services/product.service";
import { DtmService } from "../../services/dtm.service";
import { SessionStorageService } from "src/app/shared/services/session-storage.service";
import { UtilsService } from "src/app/shared/services/utils.service";
import { DiscountModalService } from "src/app/shared/services/discount-modal.service";
import { LoadingService } from "src/app/shared/services/loading.service";
import { BreadcrumbService } from "src/app/shared/services/breadcrumb.service";
import { SelfAttendanceService } from "src/app/shared/services/self-attendance.service";
import { CookieService } from "ngx-cookie-service";
import { TimeoutService } from "src/app/shared/services/timeout-data.service";
import { ECommerceService } from "src/app/services/e-commerce.service";

// Validators
import { CheckoutData } from "../../shared/model/checkout-data";
import {
	braspagReasonCode,
	errorMapping,
	handleIntegrationError,
	mappedCheckoutErrors,
	braspagTryAgainErrors,
	adyenReasonCode,
	sydleOneModalErrors
} from "../../shared/constants/errors";
// Components
import { CartComponent } from "../../shared/components/cart/cart.component";
import { DialogAlertComponent } from "../../shared/components/dialog-alert/dialog-alert.component";
// Utils
import { TimeoutData } from "src/app/shared/model/timeout-data";
import { CheckoutSuccessData } from "../../shared/model/checkout-success-data";
import { PaymentMethodOption } from "src/app/shared/model/payment-method-option";
import { DialogData } from "src/app/shared/model/dialog-data";
import { environment } from "../../../environments/environment";
import { Contexts } from "../../shared/enum/contexts";
import { filter, finalize, pairwise } from "rxjs/operators";
import { MatDialog } from "@angular/material/dialog";
import { hideChangePlanProducts } from "../../shared/constants/single-plan-products";

@Component({
    selector: 'pme-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss'],
    standalone: false
})
export class PaymentComponent implements OnInit {

	@ViewChild(PaymentFormComponent) paymentForm: PaymentFormComponent;
	@ViewChild(CartComponent) cartComponent: CartComponent;

	showCart = true;
	suggestionMessage: SuggestionMessage;
	purchaseOrigin: string;
	carts: Array<Cart>;
	cart: Cart;
	customer: Customer;
	termOfUseUrl: string;
	adyenCardError: string;
	retentionCount = 0;

	productFamily: string;
	productFamilyIdentifier: string;
	productName: string;
	valuePerMonth: string;
	totalValue: string;
	productImg: string;
	installments: number;
	productValue: string;
	discountedValue: string;

	paymentMethod: CustomerPaymentMethod;
	notLoggedSale = false

	// Provisioning variables
	userId: string;
	businessId: string;
	additionalData: any;
	productIdentifier: string;

	// Control Variables
	submitting: boolean = false;
	classificationIdentifier: string;
	classificationName: string;
	product: string;
	step = "pagamento";

	couponUrl: string;

	paymentOptions: Array<PaymentMethodOption> = [];
	changeProductText: string;
	changeProductLink: string;
	cardTitle: string;

	retentionCart: Cart;
	originalCart: Cart;

	context: string = Contexts.sale;
	discountBadge: string;

	previousUrl: string;
	currentUrl: string;
	isVendaDeslogada: boolean;
	invalidChecksum: boolean;

	// creditCardData: CreditCardData;
	creditCardsData: CreditCardData[];
	isACreditCardError: boolean = false;
	maxLimitCreditCards: boolean;
	isTelevendas: boolean;

	checkoutSubscription: any;

	timeoutTime;

	hiddenAdobeDtm = false;

	installmentSelected : {
		installment: number,
		installmentValue: number
	} = null;

	constructor(
		private cookieService: CookieService,
		private timeoutService: TimeoutService,
		private checkoutService: CheckoutService,
		private discountModalService: DiscountModalService,
		private customerService: CustomerService,
		public sessionStorageService: SessionStorageService,
		private productService: ProductService,
		private route: ActivatedRoute,
		private router: Router,
		public cartService: CartService,
		public dtmService: DtmService,
		public dialog: MatDialog,
		private utils: UtilsService,
		private loading: LoadingService,
		private breadcrumb: BreadcrumbService,
		private selfAttendanceService: SelfAttendanceService,
		private eCommerceService: ECommerceService
	) {
		this.sessionStorageService.setCustomData('disconnectedSaleStep', 'payment');
		this.sessionStorageService.setCustomData('isCheckoutSuccessfull', 'false');
		this.context = Contexts.sale
		this.productIdentifier = sessionStorageService.getCustomData('productIdentifier');
		let validationData = JSON.parse(this.sessionStorageService.getCustomData('validationData'));
		this.cartService.simulate(
			null,
			'SALE',
			this.productIdentifier,
			'IDENTIFICATION',
			[],
			validationData.userId,
			validationData.businessId,
			null,
			{}
		).subscribe({
			next: (res: Array<Cart>) => {


				this.carts = res;
				this.sessionStorageService.setCustomData('carts', JSON.stringify(this.carts));

				this.cartService.setCarts(this.carts);

				if (this.sessionStorageService.getCustomData('paymentMethod')) {
					this.cartService.setCart(this.cartService.getCartByPaymentMethod(this.sessionStorageService.getCustomData('paymentMethod')));
					this.cart = this.cartService.getCurrentCart();
				}
				else {
					this.cart = this.carts[0];
					this.cartService.setCart(this.cart);
				}


				if (this.carts) {
					this.carts.forEach(cartData => {
						this.paymentOptions.push(cartData.paymentMethod);
						if (cartData.discountBadge) {
							this.discountBadge = cartData.discountBadge;
						}
					});
				}

				if (this.cart.tdu) {
					this.termOfUseUrl = this.cart.tdu;
				} else {
					this.showCustomError('termOfUsedIntegrationError');
				}

				this.customer = this.customerService.getCurrentCustomer();
				this.setProductData();
				this.triggerOnEnter();
			},
			error: (res) => {

			}
		});

	}

	triggerOnEnter() {
		this.setProductData();
		this.dtmService.customLoaded([]);
		const provisioningParameter = this.customer.provisioningParameter;
		this.dtmService.userLoaded({
			userId: provisioningParameter.userId,
			businessId: provisioningParameter.businessId,
			clientId: SYDLEClientID
		});
		this.dtmService.pageLoaded(Dtm.PagamentoCompraDeslogada, true, getDtm(Dtm.PagamentoCompraDeslogada, this.productFamilyIdentifier));
		this.dtmService.productsLoaded([{
			identifier: this.productIdentifier,
			classificationName: this.productName,
			quantity: 1,
			totalValue: this.cart.totalValue.toFixed(2).replace(',','.'),
		},]);
		this.dtmService.sendPageLoadEvent();
	}
	ngOnInit(): void {
	}

	handleCartUpdate() {
		const carts = this.cartService.getCarts();
		this.cart = this.cartService.getCurrentCart();
		if (this.cart.paymentMethod.identifier === 'CREDIT_CARD') {
			this.installmentSelected = {
				installment: this.cart.paymentMethod.maxInstallments,
				installmentValue: this.cart.paymentMethod.maxInstallmentValue
			};
		}
		if (carts) {
			const noPaymentNeededCart = carts.find(cart => cart.allowSaleWithoutPayment);

			if (noPaymentNeededCart && noPaymentNeededCart.allowSaleWithoutPayment &&
				noPaymentNeededCart.saleMessageInfo && this.paymentForm) {
				this.cart.allowSaleWithoutPayment = true;
				this.paymentForm.hasPaymentCreditCard = false;
				this.paymentForm.hasPaymentBankBillet = false;
				this.cartComponent.allowAutomaticRecharge = false;
				this.cart.saleMessageInfo = noPaymentNeededCart.saleMessageInfo;
				this.paymentOptions = [];

				const cart = carts.filter(cartData => cartData.paymentMethod.identifier === 'BANK_BILLET')[0];
				this.paymentOptions.push(cart.paymentMethod);
			} else {
				this.cart.saleMessageInfo = null;
				this.cart.allowSaleWithoutPayment = false;
				this.paymentOptions = [];
				carts.forEach((cartData) => {
					this.paymentOptions.push(cartData.paymentMethod);
				});
			}
			this.paymentForm.handleCartUpdated(this.paymentOptions);
		}
	}

	setSubmitting(submitting: boolean) {

		this.submitting = submitting;

		if (submitting) {
			this.breadcrumb.disableBreadcrumb();
		} else {
			this.breadcrumb.enableBreadcrumb();
		}
	}

	onPaymentFormSubmitted(paymentData) {

		this.setSubmitting(true);
		this.isACreditCardError = false;

		if (this.paymentForm) {
			this.paymentForm.redirectUrl = null;
		}

		this.discountModalService.setReachedTheModalTime(false);
		if (this.invalidChecksum) {
			this.showCustomError('invalidChecksum');
			return;
		}

		this.cart = this.cartService.getCurrentCart();

		if (this.retentionCount === 1) {
			if (paymentData.identifier === "CREDIT_CARD") {
				this.retentionCart.validationData = this.cart.validationData;
				this.cart = this.retentionCart;
				paymentData.paymentConditionIdentifier = "creditCard6X";
			}
		}

		const products = this.cart.product;
		const discounts = this.cart.appliedDiscounts;
		let customer = this.customerService.getCurrentCustomer();
		const paymentMethod = paymentData;
		const sellerId = this.cart.sellerId;
		const cartId = this.cart._id;

		const isDisconnectedSale = true;

		//Flag venda deslogada
		if (this.notLoggedSale && this.cart.validationData) {
			this.cart.validationData.notLoggedSale = this.notLoggedSale;
		}

		const validationData = this.cart.validationData || {};
		validationData.fraudnetData = paymentData.fraudnetData || {};
		// TODO - como mapear mudanca de forma de pgto quando o form eh de saldo insuficiente??
		if (this.cart.paymentMethod.identifier !== paymentMethod.identifier && this.context !== Contexts.retention) {
			this.showCustomError("invalidPaymentOption");
			this.setSubmitting(false);
			return;
		}

		if (this.purchaseOrigin === 'oneClickPurchase') {
			customer.provisioningParameter.allowAutomaticRecharge = false;
		}

		const checkoutData = new CheckoutData(
			products,
			discounts,
			customer,
			paymentMethod,
			sellerId,
			this.isTelevendas ? 'televendasEcommerce' : 'e-commerce',
			cartId,
			validationData,
			isDisconnectedSale
		);

		this.cartService.log("Realizando checkout do carrinho " + checkoutData.toString());

		let timeoutId = window.setTimeout(() => {
			let timeoutData = new TimeoutData(
				paymentMethod.identifier,
				paymentMethod.card?.brand,
				products,
				discounts
			);

			this.timeoutService.setTimeoutData(timeoutData);

			// this.router.navigateByUrl(
			// 	`${this.classificationIdentifier}/checkout/processamento`
			// );

		}, 1000 * this.timeoutTime);

		this.checkoutSubscription = this.checkoutService.doCheckout(checkoutData).pipe().subscribe(
			(checkoutSuccessData: CheckoutSuccessData) => {
				this.checkoutService.setCheckoutSuccessData(checkoutSuccessData);
				clearTimeout(timeoutId);
				this.sessionStorageService.setCustomData('isCheckoutSuccessfull', 'true');
				this.navigateToNextStep();
			},
			(error) => {
				clearTimeout(timeoutId);
				this.setSubmitting(false);
				console.table(error);
				console.error(error);
				this.showCustomError("checkoutError", error);
				this.sessionStorageService.setCustomData('isCheckoutSuccessfull', 'false');
			}
		);


	}

	navigateToNextStep() {
		this.router.navigate(['../sucesso'], { relativeTo: this.route });
	}

	navigateBack() {
		//this.router.navigateByUrl(`${this.classificationIdentifier}/checkout/identificacao`);
	}
	selectedOptionInstallmentEmitter(selectedOptionInstallment) {
		this.installmentSelected ={
			installment: selectedOptionInstallment?.installments|| this.cart.paymentMethod.maxInstallments,
			installmentValue: selectedOptionInstallment?.installmentValue|| this.cart.paymentMethod.maxInstallmentValue
		}
	}

	onPaymentConditionSelected(paymentConditionOption) {

		console.log(paymentConditionOption);
		this.cartService.paymentOptionChanged.next(paymentConditionOption);
	}

	onPaymentMethodSelected(paymentMethod: string) {
		this.cartService.setCart(this.cartService.getCartByPaymentMethod(paymentMethod));
		this.cart = this.cartService.getCurrentCart();
		this.dtmService.productsLoaded([{
			identifier: this.productIdentifier,
			classificationName: this.productName,
			quantity: 1,
			totalValue: this.cart.totalValue.toFixed(2).replace(',','.'),
		},]);
		this.dtmService.customClickEvent("Troca de forma de pagamento", paymentMethod);
	}

	showCustomError(customErrorKey: string, integrationError?: any) {
		let integrationErrorMessage: any;

		switch (customErrorKey) {
			case "termOfUsedIntegrationError":
				this.paymentForm.addValidationError(
					errorMapping[customErrorKey]
				);

				// Analytics
				this.dtmService.customErrorLoaded(["error"], {
					errorDetail: errorMapping[customErrorKey],
					errorMessage: errorMapping[customErrorKey],
				});

				this.paymentForm.redirectUrl = environment.serasaHomePage;
				break;
			case "invalidPaymentOption":
				this.paymentForm.addValidationError(
					errorMapping[customErrorKey]
				);

				// Analytics
				this.dtmService.customErrorLoaded(["error"], {
					errorDetail: "PaymentOptionInválido",
					errorMessage: errorMapping[customErrorKey],
				});

				this.paymentForm.redirectUrl = environment.serasaHomePage;
				break;
			case "checkoutError":
				integrationErrorMessage = this.handleCheckoutErrors(integrationError);
				if (this.context !== Contexts.retention) {
					if (['RECENT_PURCHASE_MODAL', 'MODAL_FRAUDNET_PENDING_PURCHASE', 'FRAUDNET_REJECT', 'MODAL_EXISTS_BANKBILLET_MENSAL_PLAN', 'MODAL_EXISTS_BANKBILLET_SDSN', 'MODAL_EXISTS_BANKBILLET_MONITORE', 'MODAL_EXISTS_PIX_MENSAL_PLAN', 'MODAL_EXISTS_PIX_SDSN', 'MODAL_EXISTS_PIX_MONITORE', 'WATCHLIST_INVESTIGATE', 'WATCHLIST_REJECT_PIX', 'WATCHLIST_REJECT_BOLETO', 'WATCHLIST_REJECT_CREDITCARD', 'MODAL_WATCHLIST_PENDING_PURCHASE', 'MODAL_EXISTS_PIX_CONSULTA', 'MODAL_EXISTS_BANKBILLET_CONSULTA'].indexOf(integrationErrorMessage.userMessage) >= 0) {
						this.openErrorDialog(integrationErrorMessage.userMessage);
					} else {
						this.paymentForm.addValidationError(
							integrationErrorMessage.userMessage
						);
					}
				}
				// Analytics
				if (this.cart.paymentMethod.identifier === "CREDIT_CARD") {
					this.dtmService.customEventCreditCardPaymentError(["CreditCardPaymentError"], {
						errorTriggeredSecondaryCardAutoSelectFeature: false
					});
				}
				if (integrationErrorMessage.errorString || integrationErrorMessage.userMessage) {
					this.dtmService.customErrorLoaded(["error"], {
						errorDetail: integrationErrorMessage.errorString,
						errorMessage: integrationErrorMessage.userMessage,
					});
				} else {
					// Erro de timeout na requisicao de venda
					this.dtmService.customErrorLoaded(["error"], {
						"errorDetail": "HttpErrorResponse",
						"errorMessage": "Erro de timeout durante a venda: " + integrationErrorMessage.message
					});
				}
				break;
			case "invalidChecksum":
				this.paymentForm.addValidationError(
					errorMapping[customErrorKey]
				);

				// Analytics
				this.dtmService.customErrorLoaded(["error"], {
					errorDetail: errorMapping[customErrorKey],
					errorMessage: errorMapping[customErrorKey],
				});

				this.paymentForm.redirectUrl = environment.serasaHomePage;
				break;
			default:
				break;
		}
		this.paymentForm.submitting = false;
		this.paymentForm.enableFields("all");
	}

	handleCheckoutErrors(error: any): any {
		const resultError: any = {};
		try {
			this.isACreditCardError = false;

			if (typeof error === "string") {
				error = JSON.parse(error);
			}

			if (error.status !== null && error.error) {
				resultError.status = error.status;
				resultError.endpoint = error.url && error.url.substring(error.url.indexOf("/api/1") + 6);
				resultError.name = error.name;

				resultError.handledError = !!error.error._messages.filter((message) => {
					return message.code !== null;
				});

				resultError.errors = error.error._messages.filter((message) => {
					return message.type === "ERROR";
				});

				resultError.warnings = error.error._messages.filter((message) => {
					return message.type === "WARNING";
				});

				let parseObj;
				try {
					parseObj = JSON.parse(resultError.errors[0].text);
				} catch (err) { }

				if (parseObj && parseObj.context !== undefined) {

					resultError.context = parseObj.context;
					resultError.userMessage = parseObj.message;
					resultError.errorCode = resultError.errors[0].code || parseObj.code;
					resultError.errors[0].text = resultError.userMessage;

				} else {
					resultError.userMessage = resultError.errors[0].text;
					resultError.errorCode = resultError.errors[0].code;
				}

				this.paymentForm.braspagTryAgainErrors = Boolean(braspagTryAgainErrors[resultError.userMessage]);

				resultError.errorString = `${resultError.context || "SYDLE"}:HTTP:${resultError.errorCode || resultError.status}:POST/${resultError.endpoint}:${JSON.stringify(resultError.errors.map(({ text }) => text))}:${JSON.stringify(resultError.warnings)}`;

				if (resultError.errorCode === "402" &&
					resultError.userMessage === "Não autorizado. Saldo insuficiente.") {
					this.retentionCount += 1;
					sessionStorage.setItem("retentionCount", this.retentionCount.toString());
					this.showCart = false;
				} else if (braspagReasonCode[resultError.userMessage]) {
					resultError.userMessage = braspagReasonCode[resultError.userMessage];
				} else if (adyenReasonCode[resultError.userMessage]) {
					resultError.userMessage = adyenReasonCode[resultError.userMessage];
				} else if (mappedCheckoutErrors[resultError.userMessage]) {
					resultError.userMessage = mappedCheckoutErrors[resultError.userMessage];
				} else if (resultError.userMessage.indexOf("java") >= 0 ||
					resultError.userMessage.indexOf("Java") >= 0 ||
					resultError.userMessage.indexOf("Script") >= 0 ||
					resultError.userMessage.indexOf("script") >= 0 ||
					resultError.userMessage.indexOf("elastic") >= 0 ||
					resultError.userMessage.indexOf("Elastic") >= 0) {

					if (resultError.userMessage.indexOf("BP901") >= 0) {
						resultError.userMessage = braspagReasonCode["BP901"];
					} else if (resultError.userMessage.indexOf("Could not find an acquirer account") >= 0) {
						resultError.userMessage = adyenReasonCode["Could not find an acquirer account"];
					} else {
						resultError.userMessage = "Ocorreu um erro ao processar a solicitação, por favor tente novamente em alguns instantes.";
					}

					this.paymentForm.redirectUrl = environment.serasaHomePage;
				} else if (sydleOneModalErrors[resultError.userMessage]) {
					let errors = error.error._messages.filter(err => err.type == "ERROR");


					resultError.userMessage = errors.map(err => err.text).join(".");;
				}
				const generalMessageText = error.error.generalMessages[0]?.text;

				const parsedText = JSON.parse(generalMessageText); //trata erro referente ao cartão

				const context = parsedText?.context;
				const message = parsedText?.message;

				if (generalMessageText) {


					if (context === "ADYEN") {

						resultError.userMessage = message;


						this.adyenCardError = message;
						this.isACreditCardError = true;
						if (!this.creditCardsData) {
							this.isACreditCardError = false;

						}
					} else {

						this.isACreditCardError = false;
						this.adyenCardError = null;

					}

				}
			}
		} catch (e) {
			// resultError.errorString = JSON.stringify(error);

			resultError.userMessage = "Ocorreu um erro ao processar a sua solicitação, tente novamente em alguns instantes.";

			this.paymentForm.redirectUrl = environment.serasaHomePage;
		}

		if (resultError.context && resultError.context === "Braspag") {
			this.paymentForm.isBraspagError = true;

			if (!this.paymentForm.braspagTryAgainErrors) {
				resultError.userMessage += " Por favor, verifique os dados informados, utilize outro cartão ou efetue o pagamento com boleto.";
			}
		}

		return resultError;
	}

	/** Abre dialog em caso de erro durante a venda deslogada */
	openErrorDialog(dialogData: string, errorDetail?: string, errorMessage?: string) {
		let data = DialogData.fromPreset(dialogData, {
			classificationName: this.classificationName,
			businessId: this.businessId,
			userId: this.userId
		});

		let dialogRef = this.dialog.open(DialogAlertComponent, {
			disableClose: true,
			panelClass: 'pme-dialog-alert-panel',
			autoFocus: false,
			data: data
		});

		if (['RECENT_PURCHASE_MODAL', 'FRAUDNET_REJECT', 'MODAL_EXISTS_BANKBILLET_MENSAL_PLAN', 'MODAL_EXISTS_BANKBILLET_SDSN', 'MODAL_EXISTS_BANKBILLET_MONITORE', 'MODAL_EXISTS_PIX_MENSAL_PLAN', 'MODAL_EXISTS_PIX_SDSN', 'MODAL_EXISTS_PIX_MONITORE', 'MODAL_EXISTS_BANKBILLET_CONSULTA', 'MODAL_EXISTS_PIX_CONSULTA'].indexOf(dialogData) >= 0) {
			dialogRef.afterClosed().subscribe(result => {
				if (result && result.doCheckout) {
					this.doCheckoutRecentPurchaseModal();
				} else if (result && result.disableCreditCard) {
					this.disableCreditCardAfterFraudnetReject();
				} else if (result && result.changeToBankBillet) {
					this.changeToBankBilletAfterFraudnetReject();
				} else if (result && result.doCheckoutInThisPlan) {
					this.doCheckoutAfterExistsModalForAnotherPlan();

				}
			});
		} else {
			// Analytics

			this.dtmService.customErrorLoaded(['error'], {
				errorDetail: errorMapping[dialogData],
				errorMessage: errorMapping[dialogData],
			});

		}
	}

	doCheckoutRecentPurchaseModal() {
		this.cart.validationData.ignoreRecentPurchase = true;
		this.cartService.setCart(this.cart);
		if (this.paymentForm.isAdyen) {
			this.paymentForm.onAdyenSubmit();
		} else {
			this.paymentForm.onSubmit();
		}
	}

	doCheckoutAfterExistsModalForAnotherPlan() {
		this.cart.validationData.ignoreAnotherPlan = true;
		this.cartService.setCart(this.cart);
		if (this.paymentForm.isAdyen) {
			this.paymentForm.onAdyenSubmit();
		} else {
			this.paymentForm.onSubmit();
		}
	}

	disableCreditCardAfterFraudnetReject() {
		if (this.paymentForm.paymentData && this.paymentForm.paymentData.sameCard) {
			this.paymentForm.disableSubmitCreditCard = true;
		} else {
			this.paymentForm.paymentData = new CustomerPaymentMethod("CREDIT_CARD");
		}

		if (this.cartComponent.allowAutomaticRecharge === true) {
			this.cartComponent.onAutomaticRechargeClick({ "checked": false });
		}
	}

	changeToBankBilletAfterFraudnetReject() {
		if (this.paymentForm.paymentData && this.paymentForm.paymentData.sameCard) {
			this.paymentForm.disableSubmitCreditCard = true;
		} else {
			this.paymentForm.paymentData = new CustomerPaymentMethod("CREDIT_CARD");
		}
		if (this.cartComponent.allowAutomaticRecharge === true) {
			this.cartComponent.onAutomaticRechargeClick({ "checked": false });
		}
		// this.paymentForm.selectedIndex = 1;
		// this.paymentForm.storePaymentMethod(1);
		this.paymentForm.storePaymentMethodByIdentifier("BANK_BILLET");
	}

	/**
	 * Retorna um userMessage de erro para erros de HttpIntegrationError
	 * @param error
	 */
	getUserMessageForHttpIntegrationError(error: any): string {
		if (error && error.error) {
			error = error.error;

			if (error._messages && error._messages.length) {
				let isCvvInvalid = error._messages.some(errorMsg => errorMsg.text.includes("Código de segurança inválido"));
				if (isCvvInvalid) {
					return "Não autorizado. Código de segurança inválido. Revise os dados ou insira outro cartão.";
				}

				let isCardInexistent = error._messages.some(errorMsg => errorMsg.text.includes("Cartão inexistente"));
				if (isCardInexistent) {
					return "Transação não autorizada por conter dados inválidos. Revise os dados informados ou utilize outro cartão.";
				}

				let isCardRestricted = error._messages.some(errorMsg => errorMsg.text.includes("Cartão restrito"));
				if (isCardRestricted) {
					return "Cartão restrito. Não autorizado. Revise os dados informados ou utilize outro cartão.";
				}

				let isBP901Error = error._messages.some(errorMsg => errorMsg.text.includes("BP901"));
				if (isBP901Error) {
					return "Ocorreu um erro ao realizar a transação. Por favor revise os dados ou insira outro cartão.";
				}

				// Outras mensagens que podem ser retornadas pelo ONE
				// let errors = error._messages.filter(err => err.type == "ERROR");
				// if (errors && errors.length) {
				// 	return errors.map(err => err.text).join(".");
				// }
			}
		}

		return "Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes!";
	}

	setProductData() {
		let productData = JSON.parse(this.sessionStorageService.getCustomData('disconnectedSaleProduct'));
		let cartProductData = JSON.parse(this.sessionStorageService.getCustomData('cart'));
		this.productFamily = productData.classification;
		this.productFamilyIdentifier = productData.classificationIdentifier;
		this.productName = productData.productName;
		this.valuePerMonth = productData.installmentValue;
		this.totalValue = Number(cartProductData.totalValue).toFixed(2).replace('.', ',');
		this.productImg = productData.productImg;
		this.installments = productData.installment;
		this.installmentSelected = {
			installment: this.cart.paymentMethod.maxInstallments,
			installmentValue: this.cart.paymentMethod.maxInstallmentValue
		};
		this.productValue = Number(cartProductData.baseValue).toFixed(2).replace('.', ',');
		this.discountedValue = Number(cartProductData.discountedValue).toFixed(2).replace('.', ',');


	}

}
